// ── 메시지 복사 버튼 ─────────────────────────────
import { useState } from 'react';
import { copyToClipboard } from '../../utils/clipboard';

export default function MsgCopyButton({ text }) {
  const [copied, setCopied] = useState(false);
  const copy = () => {
    copyToClipboard(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {});
  };
  return (
    <button onClick={copy}
      title="메시지 복사"
      style={{ display: 'flex', alignItems: 'center', gap: '4px', padding: '4px 10px', background: 'none', border: '1px solid #e5e7eb', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', color: copied ? '#16a34a' : '#6b7280', minHeight: '28px', flexShrink: 0 }}>
      {copied ? '✓ 복사됨' : '복사'}
    </button>
  );
}
